module.exports = __webpack_public_path__ + "static/media/logo-pk2.ad0ddf5a.png";